'use client'

import React, { createContext, useContext, useMemo } from 'react'

interface SidebarContextType {
	isCollapsed: boolean
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined)

export function SidebarProvider({ children }: Readonly<{ children: React.ReactNode }>) {
	const value = useMemo(() => ({ isCollapsed: false }), [])
	return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
}

export function useSidebar() {
	const context = useContext(SidebarContext)
	if (context === undefined) {
		throw new Error('useSidebar must be used within a SidebarProvider')
	}
	return context
}
